<template>
  <v-app class="bg-login" id="auth">
    <v-main>
      <v-container class="fill-height">
        <v-row class="fill-height">
          <v-col cols="12" lg="5" class="hidden-md-and-down">
            <v-card flat height="100%" rounded="xl">
              <v-img src="../../assets/login_background.webp" height="100%">
                <div class="left__text white--text text-h5">
                  <p class="text-uppercase mb-0">Portal</p>
                  <p class="text-uppercase">Administrativo</p>
                </div>
              </v-img>
            </v-card>
          </v-col>
          <v-col cols="12" lg="7" class="d-flex align-center">
            <v-row>
              <v-col cols="8" offset="2">
                <div
                  class="logo-container d-flex flex-column justify-center align-center"
                >
                  <router-link :to="{ name: 'Login' }">
                    <img
                      src="../../assets/logo_av_securities.png"
                      alt="Logo Av"
                      class="logo"
                    />
                  </router-link>
                  <p class="logo-container__text silver--text mt-5">
                    ¡Bienvenido de nuevo! Por favor, ingrese a su cuenta.
                  </p>
                </div>
              </v-col>
              <v-col cols="10" offset="1">
                <v-card elevation="0" v-if="passwordReset === false">
                  <v-card-text>
                    <ValidationObserver ref="observer" v-slot="{ invalid }">
                      <form @submit.prevent="handleSubmit">
                        <v-row class="px-md-5">
                          <v-col cols="12">
                            <!-- EMAIL FIELD -->
                            <ValidationProvider
                              name="Correo electrónico"
                              rules="required|email"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                label="Correo electrónico"
                                v-model="user.email"
                                hint="Introduzca su correo electrónico"
                                :error-messages="errors[0]"
                              />
                            </ValidationProvider>
                          </v-col>
                          <!-- CURRENT PASSWORD -->
                          <v-col cols="12">
                            <ValidationProvider
                              name="Contraseña Nueva"
                              rules="required|min:8|confirmed:password"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                name="password"
                                label="Contraseña Nueva*"
                                v-model="user.password"
                                hint="Ingrese la contraseña"
                                type="password"
                                :error-messages="errors[0]"
                              />
                            </ValidationProvider>
                          </v-col>

                          <!-- NEW PASSWORD -->
                          <v-col cols="12">
                            <ValidationProvider
                              name="Confirmar Contraseña"
                              rules="required|min:8"
                              vid="password"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                label="Confirmar Contraseña*"
                                v-model="user.password_confirmation"
                                hint="Ingrese nuevamente la contraseña"
                                type="password"
                                :error-messages="errors[0]"
                              />
                            </ValidationProvider>
                          </v-col>
                        </v-row>

                        <v-row justify="center">
                          <v-btn
                            color="secondary"
                            type="submit"
                            :loading="loading"
                            :disabled="invalid"
                            :elevation="0"
                            >Cambiar contraseña</v-btn
                          >
                        </v-row>
                      </form>
                    </ValidationObserver>
                  </v-card-text>
                </v-card>
                <v-card rounded elevation="0" class="pa-6" v-else>
                  <v-card-text>
                    <v-row justify="center">
                      <span class="logo-container__text">
                        Cambio de contraseña exitoso
                      </span>
                    </v-row>

                    <v-row justify="center pt-5">
                      <v-btn
                        color="secondary"
                        :elevation="0"
                        :to="{ name: 'Login' }"
                      >
                        <span>Iniciar Sesión</span>
                      </v-btn>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { mapState } from 'vuex'
import UserService from '@/services/user'
export default {
  data() {
    return {
      isLoading: false,
      passwordReset: false,
      user: {
        token: this.$route.query.token,
        email: '',
        password: '',
        password_confirmation: ''
      }
    }
  },
  created() {
    this.user.email = this.$route.query.email
  },
  computed: {
    ...mapState(['loading']),
    imgCard() {
      // return require('@/assets/logo-safe.png')
      return ''
    }
  },
  methods: {
    async handleSubmit() {
      try {
        await UserService.updatePassword(this.user, false)
        this.passwordReset = true
      } catch (e) {
        this.$dialog.notify.error(e)
      }
    }
  }
}
</script>
<style>
#auth label.v-label {
  transform: translateY(-18px) scale(.75);
}
</style>
<style scoped>
.logo {
  max-width: 350px;
}
.theme--light.v-application.bg-login {
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  content: '';
  z-index: 0;
  background-color: #ffffff;
}

.left__text {
  position: absolute;
  left: 20px;
  bottom: 20px;
}

.links a {
  font: normal normal normal 16px/27px 'Libre Franklin';
  letter-spacing: 0px;
  color: #00559e;
  opacity: 1;
  text-decoration: none;
}
.login-button {
  width: 208px;
  background: transparent linear-gradient(112deg, #00559e 0%, #0090df 100%) 0%
    0% no-repeat padding-box;
  box-shadow: 6px 10px 14px #00000029;
  border-radius: 28px;
  opacity: 1;
}
.logo-container__text {
  margin-top: 20px;
  text-align: center;
  line-height: 1.5 !important;
  font: normal normal normal 18px/14px 'Libre Franklin';
  letter-spacing: 0px;
  color: #8990ad;
  opacity: 1;
}

.logo-container__text_two {
  text-align: center;
  line-height: 1.5 !important;
  font: normal normal normal 18px/14px 'Libre Franklin';
  letter-spacing: 0px;
  color: #8990ad;
  opacity: 1;
}
.logo-container__image {
  width: 90%;
}
.bg-login {
  font: normal normal normal 16px/27px 'Libre Franklin';
}
.form label {
  font: normal normal normal 12px/15px 'Libre Franklin';
  letter-spacing: 0px;
}
.text-sm {
  font-size: 15px;
}

.btn-default {
  background: transparent linear-gradient(112deg, #00559e 0%, #0090df 100%) 0%
    0% no-repeat padding-box;
  box-shadow: 6px 10px 14px #00000029;
  border-radius: 28px;
  padding: 10px;
  opacity: 1;
  text-decoration: none;
}

.btn-default > span {
  text-align: center;
  font: normal normal normal 16px/19px 'Libre Franklin';
  letter-spacing: -0.4px;
  padding: 18px;
  color: #ffffff;
  text-transform: uppercase;
  opacity: 1;
}

@media (max-width: 979px) {
  .logo-container__text {
    font: normal normal normal 16px/18px 'Libre Franklin';
  }
  .logo-container__text_two {
    font: normal normal normal 16px/18px 'Libre Franklin';
  }
  .text-left {
    font: normal normal normal 12px/27px 'Libre Franklin';
  }
}
</style>
